/*
 * Splitting the backend's blockers into the ones the practice can act on and the one it cannot
 * (KIN-1943).
 *
 * "No message has been received from the maternity hospital yet" is not a data-entry problem —
 * shared care is hospital-initiated (KIN-1054) and the practice can do nothing but wait. Listed
 * alongside "add the patient's PPSN" it invites someone to go hunting for a mistake that does not
 * exist, so it is shown separately and worded as a status rather than a fault.
 */

// Matched on the phrase rather than an exact string: the backend owns this sentence and appends a
// second one explaining the rule, so an equality check would silently stop recognising it the
// first time that wording is extended. Anything unrecognised falls through to the actionable
// list, which is the safe direction — a blocker shown as fixable is better than one hidden.
const HOSPITAL_GATE_PHRASE = "no message has been received from the maternity hospital";

export const isHospitalGateBlocker = (blocker) =>
  typeof blocker === "string" &&
  blocker.toLowerCase().includes(HOSPITAL_GATE_PHRASE);

/**
 * @returns {{ waitingOnHospital: string[], fixable: string[] }}
 */
export const splitMncmsBlockers = (blockers) => {
  const list = Array.isArray(blockers)
    ? blockers.filter((entry) => typeof entry === "string" && entry.trim())
    : [];

  return {
    waitingOnHospital: list.filter(isHospitalGateBlocker),
    fixable: list.filter((entry) => !isHospitalGateBlocker(entry)),
  };
};
